// Module
var code = `<!-- clDefinitionList — term/definition pairs.
     Data shape: { items: [ { term: "plain string", definition: "markdown string" }, ... ] }
     Renders a semantic <dl>. Term and definition both interpolate as-is via {{.}}-style
     substitution, so markdown-parsed HTML in definition renders correctly. -->
<dl class="block-cl-definition-list">
  {{#items}}
  <dt class="block-cl-definition-list__term">{{term}}</dt>
  <dd class="block-cl-definition-list__definition">{{definition}}</dd>
  {{/items}}
</dl>
`;
// Exports
module.exports = code;